import styled from 'styled-components'

export const StyledValidationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const StyledValidationText = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 135%;
  color: ${({ isValid }) => (isValid ? '#252521' : '#757575')};
`

export const StyledValidationError = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 135%;
  color: #ff2d55;
`

export const StyledValidationInstruction = styled.div`
  margin-top: 8px;
  text-align: left;
  font-size: 10px;
  line-height: 135%;
  color: #222222;
`

export const StyledValidationItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
`

export const StyledValidationItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  ${StyledValidationText} {
    flex: 1;
  }
`

export const StyledIcon = styled.div`
  width: ${({ width }) => width};
  fill: ${({ fill }) => fill};
  stroke: ${({ stroke }) => stroke};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  &:hover {
    stroke: ${({ hoverStroke }) => hoverStroke};
    fill: ${({ hoverFill }) => hoverFill};
  }
  svg {
    width: 100%;
    height: 100%;
  }
  @media screen and (min-width: 768px) {
    width: ${({ tabletWidth }) => tabletWidth};
  }
  @media screen and (min-width: 1024px) {
    width: ${({ desktopWidth }) => desktopWidth};
  }
  @media screen and (min-width: 1440px) {
    width: ${({ largeWidth }) => largeWidth};
  }
`
